// announcements-layer/composables/useAnnouncementsLocationId.ts
import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import { useLocation } from '@common/location-layer/composables/useLocation'

/**
 * Resolves the location id for learner announcement APIs.
 * In GoKollab group learning, pass the group's offer location (group.locationId);
 * otherwise falls back to the portal location store (GOKOLLAB_LOCATION_ID on gokollab).
 *
 * When a location getter is provided, an empty string means the group location is still
 * loading — do not fall back to the portal tenant. Pass `undefined` from the getter
 * (e.g. `props.locationId || undefined` on portal pages) to use the portal default.
 */
export function useAnnouncementsLocationId(locationId?: MaybeRefOrGetter<string | undefined>) {
  const { locationId: portalLocationId } = useLocation()

  return computed(() => {
    if (locationId === undefined) {
      return portalLocationId.value
    }

    const explicitLocationId = toValue(locationId)

    if (explicitLocationId === undefined) {
      return portalLocationId.value
    }

    const trimmedLocationId = explicitLocationId.trim()
    if (trimmedLocationId) {
      return trimmedLocationId
    }

    return undefined
  })
}
